import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Slide } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";

import { fontMerriweather, fontRoboto, setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { BundledNewsletterCategorySlideshow } from "scmp-app/components/newsletter/bundled-newsletter-category-item-slideshow";
import { NewsletterCategorySlideshow } from "scmp-app/components/newsletter/newsletter-category-item-slideshow";
import { List } from "scmp-app/components/newsletter/newsletter-category-item-slideshow/styles";
import { NewsletterColumnistSlideshow } from "scmp-app/components/newsletter/newsletter-columnist-slideshow";

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  align-items: center;

  margin-block-start: 20px;

  font-weight: 400;
  font-family: ${fontMerriweather};
  line-height: normal;
  text-align: center;

  span {
    color: #4585ff;
  }
  ${theme.breakpoints.up("tablet")} {
    row-gap: 4px;

    margin-block-start: 40px;
  }
`;

export const SignUpText = styled.div`
  font-size: 20px;

  ${theme.breakpoints.up("tablet")} {
    font-size: 28px;
  }
`;

export const EmailAlertsText = styled.div`
  font-size: 36px;

  ${theme.breakpoints.up("tablet")} {
    font-size: 40px;
  }
`;

export const SubHeading = styled.div`
  margin-block: 20px;

  font-size: 14px;
  font-family: ${fontMerriweather};
  line-height: normal;
  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    margin-block: 40px;

    font-size: 16px;
  }
`;

export const CategoryListContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 8px;
  row-gap: 12px;
  justify-content: center;

  margin-block: 40px 60px;
`;

export const CategorySwiperContainer = styled.div`
  /** setting this because the desktop showing this element first then the 'CategoryListContainer' */
  /** set min height for desktop to prevent CLS */
  min-block-size: 76px;
  margin-block: 40px 60px;

  ${theme.breakpoints.down("tablet")} {
    /* need to unset min height for mobile view */
    min-block-size: unset;
    margin-block: 20px 40px;

    .swiper-wrapper {
      inline-size: fit-content;
    }

    ${setFullViewportWidthStyles()}
  }
`;

export const CategorySwiper = styled(Swiper)``;

export const CategorySwiperSlide = styled(SwiperSlide)`
  &.swiper-slide {
    inline-size: auto;
    block-size: auto;
  }
`;

export const Category = styled.div`
  align-self: center;

  padding-block: 8px;
  padding-inline: 12px;

  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  white-space: nowrap;
  text-align: center;

  border: 1px solid #cccccc;
  border-radius: 100px;

  cursor: pointer;

  &:hover {
    background: #4585ff1a;
  }
`;

export const NewsletterCategorySlideshowContainer = styled.div<{ $isEmbed?: boolean }>`
  margin-block-end: 30px;

  ${props =>
    props.$isEmbed &&
    css`
      last-child {
        margin-block-end: 0;
      }
    `}

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 50px;

    ${props =>
      props.$isEmbed &&
      css`
        last-child {
          margin-block-end: 0;
        }
      `}
  }
`;

type ContainerProps = {
  $isEmbed?: boolean;
};

export const Container = styled.div<ContainerProps>`
  max-inline-size: 908px;
  margin-inline: auto;

  ${props =>
    props.$isEmbed &&
    css`
      ${theme.breakpoints.down("tablet")} {
        padding-inline: 20px;
      }

      ${theme.breakpoints.up("tablet")} {
        ${Heading} {
          margin-block-start: 0;
        }
      }
    `}
`;

export const NewsletterWidgetContainer = styled.div`
  ${setFullViewportWidthStyles()}
  position: fixed;
  inset-block-end: 0;

  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;

  padding-block: 20px 40px;

  background: #ecf3ff;

  border-block-start: 2px solid #4585ff;
`;

export const StyledSlide = styled(Slide)`
  z-index: 1;
`;

export const StyledNewsletterCategorySlideshow = styled(NewsletterCategorySlideshow)`
  display: flex;
  flex-direction: column;

  inline-size: 100%;

  ${theme.breakpoints.down("tablet")} {
    ${List} {
      ${setFullViewportWidthStyles()}
    }
  }
`;

export const StyledNewsletterColumnistSlideshow = styled(NewsletterColumnistSlideshow)`
  display: flex;
  flex-direction: column;

  inline-size: 100%;

  ${theme.breakpoints.down("tablet")} {
    ${List} {
      ${setFullViewportWidthStyles()}
    }
  }
`;

export const StyledBundledNewsletterCategorySlideshow = styled(BundledNewsletterCategorySlideshow)`
  display: flex;
  flex-direction: column;

  inline-size: 100%;
`;
